// ===================================================================
// ⚠️ COMPONENTE DE ALERTA
// ===================================================================

import React from 'react';
import { styles } from '../../styles/globalStyles';

export const Alert = React.memo(({ message, type = 'error', onClose }) => {
  const alertStyles = {
    ...styles.alert,
    ...(type === 'success' && styles.alertSuccess),
    ...(type === 'error' && styles.alertError),
    ...(type === 'warning' && styles.alertWarning),
    ...(type === 'info' && styles.alertInfo)
  };

  return (
    <div style={alertStyles}>
      <span>{message}</span>
      {onClose && (
        <button 
          onClick={onClose}
          aria-label="Fechar"
          style={{
            background: 'rgba(0,0,0,0.06)',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            marginLeft: 'auto',
            fontSize: '18px',
            padding: '4px 8px',
            lineHeight: 1
          }}
        >
          ×
        </button>
      )}
    </div>
  );
}); 